import type { PageContext } from 'vike/types'
// export default '/playalong/*'

// Route Function
export function route(pageContext: PageContext): any {
    const match = pageContext.urlPathname.match(/^\/playalong\/(.+)$/)
    if (match === null) {
        if (pageContext.urlPathname === '/playalong') {
            return { routeParams: { id: '' } }
        }
        return false
    }
    const [, episode] = match
    return { routeParams: { id: episode ?? '' } }
}
